import { SelectProps } from "@mui/material";
import { ConditionValueSelectorComponentProps } from "../ConditionForm";
import EnumSelect from "../../../common/EnumSelect";
import enumLabel from "../../../../utils/labels/enumLabel";
import { FuelCostPeriod } from "../../../../graphql/generated";

export const DEFAULT_FUEL_COST_PERIOD = FuelCostPeriod.Weekly;

const FuelCostPeriodSelect = ({
  value,
  onChange,
  ...otherProps
}: ConditionValueSelectorComponentProps & Pick<SelectProps<string>, "sx">) => (
  <EnumSelect data-testid="fuel-cost-period-select-fuel-cost-period"
    label={otherProps.label}
    size="small"
    enumObject={FuelCostPeriod}
    value={(value as FuelCostPeriod) || DEFAULT_FUEL_COST_PERIOD}
    onChange={(event, value) => {
      onChange(value);
    }}
    optionLabel={(option) => enumLabel(option) || option}
    {...otherProps}
  />
);

export default FuelCostPeriodSelect;
